// ─── DESIGN TOKENS ───────────────────────────────────
// Edit these values to restyle the entire site

export const TOKENS = {
  // ── CONTACT (update these first!) ──────────────────
  PHONE_DISPLAY:  '+91 9217665532',         // shown on page
  PHONE_HREF:     'tel:+919217665532',        // dial link
  WHATSAPP_NUM:   '919217665532',             // wa.me number (no +)
  WHATSAPP_MSG:   'Hi%2C%20I%20am%20interested%20in%20the%20225%20Sq.%20Yard%20commercial%20property%20at%20Jhandewalan%2C%20Central%20Delhi.%20Please%20share%20details.',

  // ── PROPERTY DETAILS ────────────────────────────────
  PRICE:          '₹5.55 Cr',
  PRICE_LABEL:    'Negotiable',
  PLOT_SIZE:      '225',
  PLOT_UNIT:      'Sq. Yards',
  PROP_TYPE:      'Industrial / Commercial',
  LOCATION:       'Jhandewalan, Central Delhi',

  // ── GOOGLE MAPS ─────────────────────────────────────
  MAP_SRC: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.8!2d77.2012!3d28.6436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd7fb83b93cf%3A0xf14b0aad2d7e4ca5!2sJhandewalan%2C%20New%20Delhi!5e0!3m2!1sen!2sin!4v1700000000000',

  // ── COLOURS ─────────────────────────────────────────
  GOLD:      '#C8A96A',
  GOLD_LIGHT:'#D4B97A',
  BLACK:     '#050A1a',
  OFF_BLACK: '#060A1F',
  DARK:      '#0A0F2A',
  MUTED:     '#6E6E73',
  WHITE:     '#FFFFFF',
};

export const WA_LINK = (msg = TOKENS.WHATSAPP_MSG) =>
  `https://wa.me/${TOKENS.WHATSAPP_NUM}?text=${msg}`;
